
<!-- Top Navbar -->
<div class="vault-topnav">
  <div class="nav-left">
    <!-- Replaces the hamburger, which toggled the removed icon rail and so
         did nothing. Mobile only: on desktop the vault's own header carries
         the logo already. -->
    <img
      src="assets/login/link-logo.png"
      alt="Home"
      class="topnav-logo"
      (click)="navigateTo('home')"
      title="Back to home"
    />
  </div>
</div>

<!-- The icon rail is gone: with Gallery removed it held a single Home link,
     and it expanded over the content on hover. The vault's own header now
     carries the logo, which navigates home. -->

